import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';

export const trackSwitchNCUC = (
  trackingService: TrackingServiceV2,
  eventName: string,
  label: string,
  value: string,
  targetURL: string
) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: 'internal_link',
          eventName,
        },
        attributes: {
          componentName: 'vtp-quick-filter',
          label,
          targetURL,
          clickID: '',
          elementName: 'button',
          value,
          pos: '',
        },
      },
    });
  }
};

export const trackOpenFilterOverlay = (trackingService: TrackingServiceV2, label: string) => {
  if (trackingService) {
    // click on advanced filter button in quick filters to open the filter overlay
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: 'internal_link',
          eventName: 'vtp quick filter - go to advanced filters',
        },
        attributes: {
          componentName: 'vtp-quick-filter',
          label,
          targetURL: '',
          clickID: '',
          elementName: 'button',
          value: '',
          pos: '',
        },
      },
    });
    // page event for the filter overlay triggered by opening the filter overlay via the advanced filter button in quick filters
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: 'view_change',
          eventName: 'vtp filter - filter layer',
        },
        attributes: {
          componentName: 'vtp-filter',
          label: '',
          targetURL: '',
          clickID: '',
          elementName: '',
          value: '',
          pos: '',
        },
      },
      componentUpdate: {
        page: {
          pageInfo: {
            layerName: ['vtp filter layer'],
          },
        },
      },
    });
  }
};

export const trackFilterLayerOnMobile = (trackingService: TrackingServiceV2) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: 'content',
          eventName: 'vtp quick filter - open quick filters',
        },
        attributes: {
          componentName: 'vtp-quick-filter',
          label: '',
          targetURL: '',
          clickID: '',
          elementName: 'other',
          value: '',
          pos: '',
        },
      },
    });
  }
};

export const trackShowResultsOnMobile = (trackingService: TrackingServiceV2, label: string) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: 'content',
          eventName: 'vtp quick filter - click to show results',
        },
        attributes: {
          componentName: 'vtp-quick-filter',
          label,
          targetURL: '',
          clickID: '',
          elementName: 'button',
          value: '',
          pos: '',
        },
      },
    });
  }
};

export const trackShareClick = (trackingService: TrackingServiceV2, label: string) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: 'content',
          eventName: 'vtp share',
        },
        attributes: {
          label,
          componentName: 'vtp-results',
          elementName: 'icon',
          value: '',
          targetUrl: '',
        },
      },
    });
  }
};
